import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEvents } from "../Utils/FrameTimer";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";

@engineComponent(ComponentTypes.DisplayObject)
/**
 * Example:
 * <VegetationLeft Class="SkewElement" FromFrame="GFX_vegetationLeft" X="0" Y="434" Alpha="0.8" PivotX="0" PivotY="217"
 *      MinSpeed="-0.02" AccelerationToMin="1.05" DecelerationToMin="0.95" MinSkew="0" MinRandom="0"
 *      MaxSpeed="0.01" AccelerationToMax="1.05" DecelerationToMax="0.95" MaxSkew="1.45" MaxRandom="0.5"/>
 */
export class SkewElement extends ImageElement {
    public create(node: Element): void {
        super.create(node);

        let minSpeed = node.hasAttribute(SkewElementAttributes.MIN_SPEED)
            ? this.degrees2radians(parseFloat(node.getAttribute(SkewElementAttributes.MIN_SPEED)))
            : 0;
        let accelerationToMin = node.hasAttribute(SkewElementAttributes.ACCELERATION_TO_MIN)
            ? parseFloat(node.getAttribute(SkewElementAttributes.ACCELERATION_TO_MIN))
            : 0;
        let decelerationToMin = node.hasAttribute(SkewElementAttributes.DECELERATION_TO_MIN)
            ? parseFloat(node.getAttribute(SkewElementAttributes.DECELERATION_TO_MIN))
            : 0;
        let minSkew = node.hasAttribute(SkewElementAttributes.MIN_SKEW)
            ? this.degrees2radians(parseFloat(node.getAttribute(SkewElementAttributes.MIN_SKEW)))
            : 0;
        let minRandom = node.hasAttribute(SkewElementAttributes.MIN_RANDOM)
            ? this.degrees2radians(parseFloat(node.getAttribute(SkewElementAttributes.MIN_RANDOM)))
            : 0;

        let maxSpeed = node.hasAttribute(SkewElementAttributes.MAX_SPEED)
            ? this.degrees2radians(parseFloat(node.getAttribute(SkewElementAttributes.MAX_SPEED)))
            : 0;
        let accelerationToMax = node.hasAttribute(SkewElementAttributes.ACCELERATION_TO_MAX)
            ? parseFloat(node.getAttribute(SkewElementAttributes.ACCELERATION_TO_MAX))
            : 0;
        let decelerationToMax = node.hasAttribute(SkewElementAttributes.DECELERATION_TO_MAX)
            ? parseFloat(node.getAttribute(SkewElementAttributes.DECELERATION_TO_MAX))
            : 0;
        let maxSkew = node.hasAttribute(SkewElementAttributes.MAX_SKEW)
            ? this.degrees2radians(parseFloat(node.getAttribute(SkewElementAttributes.MAX_SKEW)))
            : 0;
        let maxRandom = node.hasAttribute(SkewElementAttributes.MAX_RANDOM)
            ? this.degrees2radians(parseFloat(node.getAttribute(SkewElementAttributes.MAX_RANDOM)))
            : 0;

        let toMax = true;
        let speed = maxSpeed;
        let easing = accelerationToMax;
        let random = new PIXI.Point(Math.random() * minRandom, Math.random() * maxRandom);
        let threshold = (minSkew + maxSkew + random.x + random.y) / 2;

        /*let radianIncrement = 0;
        let randMultiplier = 1;
        let generateNew = false;*/

        this.skew.x = minSkew + random.x;

        const wave = function (): void {
            if (toMax) {
                if (this.skew.x >= threshold) {
                    easing = decelerationToMax;
                }

                speed *= easing;

                this.skew.x += speed;

                if (this.skew.x >= maxSkew + random.y) {
                    this.skew.x = maxSkew + random.y;

                    toMax = false;
                    speed = minSpeed;
                    easing = accelerationToMin;
                    random.x = Math.random() * minRandom;
                    threshold = (minSkew + maxSkew + random.x + random.y) / 2;
                }
            } else {
                if (this.skew.x <= threshold) {
                    easing = decelerationToMin;
                }

                speed *= easing;

                this.skew.x += speed;

                if (this.skew.x <= minSkew + random.x) {
                    this.skew.x = minSkew + random.x;

                    toMax = true;
                    speed = maxSpeed;
                    easing = accelerationToMax;
                    random.y = Math.random() * maxRandom;
                    threshold = (minSkew + maxSkew + random.x + random.y) / 2;
                }
            }

            timer.start(2);
        };

        const timer = CreateFrameTimer("skew");
        timer.on(FrameTimerEvents.Complete, wave, this);
        timer.start(2);
    }
}

const SkewElementAttributes = {
    /**
     *
     */
    ACCELERATION_TO_MAX: "AccelerationToMax",
    /**
     * Acceleration to right. Value need to be >= 1
     * @type {number}
     */
    ACCELERATION_TO_MIN: "AccelerationToMin",
    /**
     *
     */
    DECELERATION_TO_MAX: "DecelerationToMax",
    /**
     * Deceleration to right. Value need to be < 1
     * @type {number}
     */
    DECELERATION_TO_MIN: "DecelerationToMin",
    /**
     *
     */
    MAX_RANDOM: "MaxRandom",
    /**
     *
     */
    MAX_SKEW: "MaxSkew",
    /**
     *
     */
    MAX_SPEED: "MaxSpeed",
    /**
     *
     */
    MIN_RANDOM: "MinRandom",
    /**
     *
     * @type {number}
     */
    MIN_SKEW: "MinSkew",
    /**
     *
     */
    MIN_SPEED: "MinSpeed",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/SkewElement.ts
 **/